// Utility function to generate dashboard URL with current date
// Format: admin + AAMMJJ (Year Month Day - 2 digits each)
// Example: 26/02/26 → admin260226

export const getDashboardUrl = () => {
  const now = new Date();
  const year = now.getFullYear().toString().slice(-2); // Last 2 digits
  const month = (now.getMonth() + 1).toString().padStart(2, '0'); // 01-12
  const day = now.getDate().toString().padStart(2, '0'); // 01-31
  
  return `/admin${year}${month}${day}`;
};

export const getTodayDateCode = () => {
  const now = new Date();
  const year = now.getFullYear().toString().slice(-2);
  const month = (now.getMonth() + 1).toString().padStart(2, '0');
  const day = now.getDate().toString().padStart(2, '0');
  
  return `${year}${month}${day}`;
};

// Verify if the URL matches today's date
export const isValidDashboardUrl = (urlPath) => {
  const expectedUrl = getDashboardUrl();
  return urlPath === expectedUrl;
};
